// @ts-nocheck
import getImageSize from "@toolkit/Framework/Common/Utilities/getImageSize";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { pxToRem, pxToRemArray } from "@toolkit/Framework/Common/Utilities/unitHelper";

const design: Styleguide["design"] = {
    product: {
        image: {
            small: getImageSize(210),
            medium: getImageSize(768),
            large: getImageSize(1200),
        },
    },
    category: {
        image: {
            small: getImageSize(768),
        },
    },
    typography: {
        fontFamily: {
            /* Store Custom Code - Start */
            title: `"FLS Sans", Arial, Helvetica, sans-serif`,
            base: `"FLS Sans", Arial, Helvetica, sans-serif`,
            /* Store Custom Code - End */
        },
        weight: {
            thin: 100,
            extralight: 200,
            light: 300,
            base: 400,
            medium: 500,
            semibold: 600,
            /* Store Custom Code - Start */
            bold: 600,
            extrabold: 700,
            /* Store Custom Code - End */
            black: 900,
        },
    },
    layout: {
        contentWidth: 1410,
        spacing: {
            side: pxToRemArray([20, 30, 45, null, 60]),
            content: pxToRemArray([25, 30, 45, null, 60]),
            narrowContent: pxToRemArray([25, 30, 40, null, 50]),
            /* Store Custom Code - Start */
            spacedContent: pxToRemArray([30, 40, 75, null, 100]),
            /* Store Custom Code - End */
        },
    },
    header: {
        height: pxToRemArray([75, null, 94, 94, 94]),
        padding: pxToRemArray([0]),
        iconButton: {
            size: pxToRemArray([30, null, 40]),
            padding: pxToRemArray([0]),
        },
    },
    menu: {
        mainNavigation: {
            itemSpacing: pxToRemArray([30, null, null, 20, 20]),
            underlineSize: pxToRem(2),
        },
        secondaryNavigation: {
            height: pxToRemArray([60]),
        },
    },
};

export default design;
